import { useMemo } from 'react';
import errorService from '@services/errorService';

/**
 * Derive a user-facing message from an RTK Query error result.
 *
 * Returns `null` when there is no error, otherwise routes the error through
 * `errorService.toUserMessage()` so the backend's `detail` message is surfaced
 * consistently instead of a hand-rolled generic string. Use this to render a
 * query/fetch error inline rather than mirroring it into local state via a
 * `useEffect` + `useState`.
 */
export function useQueryError(error: unknown): string | null {
  return useMemo(() => (error ? errorService.toUserMessage(error) : null), [error]);
}
